/**
 * These permissions represent things that this user is generally allowed to do.
 */
export default {
  ACCESS_OWN_PROFILE: 'access_own_profile', // todo: remove.  this should be native feature
  ACCESS_RESOURCE_LIBRARY: 'access_resource_library',
  INIT_MATCH_RUN: 'init_match_run',
  CAN_INVEST: 'can_invest',
  INIT_BACKGROUND_CHECK: 'init_background_check',
  CRUD_POSTS: 'crud_posts',
  POST_TO_MULTIPLE_TARGETS: 'post_to_multiple_targets',
  CRUD_GOALS: 'crud_goals',
  VIEW_ALL_TEAMS: 'view_all_teams',
  ACCESS_GROW: 'access_grow',
};
